import { render } from "./CustomItemForm.vue?vue&type=template&id=ba4631f8"
import script from "./CustomItemForm.vue?vue&type=script&lang=js"
export * from "./CustomItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__